import _ from 'lodash';
import { fork, put, select, takeLatest } from 'redux-saga/effects';

import {
    getCurrentLocation,
    getHistory,
    isNotCurrentRelativeURL,
    navigateTo,
    updateURLTo
} from './HistoryProvider';
import {
    BOOTSTRAP_ROUTER,
    CHANGE_ROUTER,
    CONFIRM_REROUTING,
    REQUEST_CHANGE_ROUTER,
    UPDATE_URL
} from './IwRouter.actions';
import {
    addQueryParameterInLocation,
    buildEvent,
    buildWhiteListedSearchParams
} from './LocationHelper';

export const routerSagaWorkers = [
    fork(requestChangeRouterWorker),
    fork(bootstrapRouterWorker),
    fork(updateURLRouterWorker)
];

function* bootstrapRouterWorker() {
    yield takeLatest(BOOTSTRAP_ROUTER, function* () {
        const event = buildEvent(getHistory());
        yield put({ type: CHANGE_ROUTER, ...event });
    });
}

function* requestChangeRouterWorker() {
    yield takeLatest(REQUEST_CHANGE_ROUTER, function* (action) {
        const routerBlocked = yield select(
            (state) => state.history.routerBlocked
        );

        const { impersonating, impersonatingStateKey } = yield select(
            ({ siteContext }) => siteContext
        );

        if (impersonating) {
            action.location = addQueryParameterInLocation(
                action.location,
                'state_key',
                impersonatingStateKey
            );
        }

        // Preserve whitelisted query parameters
        const currentSearchParams = buildWhiteListedSearchParams();
        for (const [key, value] of currentSearchParams.entries()) {
            action.location = addQueryParameterInLocation(
                action.location,
                key,
                value
            );
        }

        if (routerBlocked) {
            yield put({
                type: CONFIRM_REROUTING,
                location: getCurrentLocation()
            });
        } else {
            //TODO: this should be yielded
            navigateTo(action.location);
        }
    });
}

function* updateURLRouterWorker() {
    yield takeLatest(UPDATE_URL, function* (action) {
        if (isNotCurrentRelativeURL(action.pathname, action.search)) {
            let updatedLocation = {
                pathname: action.pathname,
                search: ''
            };

            if (_.isString(action.search)) {
                updatedLocation.search = action.search;
            }

            const { impersonating, impersonatingStateKey } = yield select(
                ({ siteContext }) => siteContext
            );

            if (impersonating) {
                updatedLocation = addQueryParameterInLocation(
                    updatedLocation,
                    'state_key',
                    impersonatingStateKey
                );
            }

            yield updateURLTo(updatedLocation, action.options);
        }
    });
}
